interface Props {
  label: string;
  value: boolean;
  options: [boolean, string][];
  disabled: boolean;
  onChange: (value: boolean) => void;
}

/** A yes/no setting of a page's map, as a two-way segmented control. */
export default function FiguresChoice({ label, value, options, disabled, onChange }: Props) {
  return (
    <div className="flex items-center justify-between gap-3 pt-2">
      <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</span>
      <div className="flex bg-slate-100 dark:bg-slate-800 rounded-xl p-0.5" role="radiogroup" aria-label={label}>
        {options.map(([option, text]) => (
          <button
            key={String(option)}
            role="radio"
            aria-checked={value === option}
            disabled={disabled}
            onClick={() => onChange(option)}
            className={`px-3 py-1.5 rounded-lg text-xs font-medium cursor-pointer ${
              value === option ? 'bg-white shadow-sm text-slate-900 dark:bg-slate-700 dark:text-slate-100' : 'text-slate-500'
            }`}
          >
            {text}
          </button>
        ))}
      </div>
    </div>
  );
}
